var map = {
	"./fondo/fondoopacity.svg": "1c43",
	"./fondo/fondoopacity3.svg": "facc",
	"./imagenes_compartidas/Sin título-1-10.svg": "c658",
	"./imagenes_compartidas/check.svg": "7b12",
	"./imagenes_compartidas/download-pdf2.svg": "f05f",
	"./unidad1/infografia/1.svg": "e7ea",
	"./unidad1/infografia/2.svg": "b0c8",
	"./unidad1/infografia/3.svg": "3349",
	"./unidad1/infografia/4.svg": "d1f8",
	"./unidad1/mod10/cierre.svg": "2520"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d20d";